/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Aside_PromptInputs */

const en_auth_signup_aside_prompt = /** @type {(inputs: Auth_Signup_Aside_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already have an account?`)
};

const pl_auth_signup_aside_prompt = /** @type {(inputs: Auth_Signup_Aside_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masz już konto?`)
};

/**
* | output |
* | --- |
* | "Already have an account?" |
*
* @param {Auth_Signup_Aside_PromptInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_signup_aside_prompt = /** @type {((inputs?: Auth_Signup_Aside_PromptInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Aside_PromptInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_signup_aside_prompt(inputs)
	return en_auth_signup_aside_prompt(inputs)
});